"use strict";

var React = require("react");
var LinkedStateMixin = require("react-addons-linked-state-mixin");
var Input = require("react-bootstrap").Input;
var Button = require("react-bootstrap").Button;
var Checkbox = require("react-bootstrap").Checkbox;
import Logo from '../../../images/blue-logo.png';
var cx = require("classnames");


var LoginSidebar = React.createClass({
  mixins: [LinkedStateMixin],
  getInitialState: function() {
    var email = "";
    var password = "";
    var rightPanelActive = false;
    var signupLoading = false;
    return {email,password,rightPanelActive};
  },
  login: function(){
    var email = this.state.email;
    var password = this.state.password;
    this.props.login(email, password);
  },
  signUp: function(){
    var name = this.state.signup_name;
    var email = this.state.signup_email;
    var password = this.state.signup_password;
    var company = this.state.signup_company || name;
    this.setState({"signupLoading": true});
    this.props.signUp(name, email, password, company);
  },
  onKeyDown: function(event) {
    // Allow login by pressing ENTER key.
    if(this.state.rightPanelActive) {
      if(event.keyCode === 13) {
        this.signUp();
      }
    } else {
      if(event.keyCode === 13) {
        this.login();
      }
    }
  },
  onSignupClose: function() {
    this.setState({"signupLoading": false, "rightPanelActive": false});
  },
  onToggleForm: function() {
    this.setState({"rightPanelActive": !this.state.rightPanelActive});
  },
  render: function() {
    var eqListClass = cx({
        "LoginSidebar": true,
        "right-panel-active": this.state.rightPanelActive,
        "left-panel-active": !this.state.rightPanelActive
    });
    var signUpContainerClass = cx({
      "form-container": true,
      "sign-up-container": true,
      "loading": this.state.signupLoading && !this.props.loading && !this.props.signUpError
    });
    return (
        <div className={eqListClass} >
            <div className="login-logo"></div>
            <div className={signUpContainerClass}>
              <div className="signup-close" onClick={this.onSignupClose}><i className="far fa-times-circle"></i></div>
              <div className="signup-success-container">
                <h1>Nýskráning tókst!</h1>
                <p>Skoðaðu tölvupóstinn þinn, þú ættir að hafa fengið staðfestingarpóst. Smelltu á tengilinn í þeim pósti til að klára skráninguna og skrá þig inn. </p>
              </div>
              <div id="login-form" className="form-group" onKeyDown={this.onKeyDown}>
                <h1>Stofna aðgang</h1>

                <Input label="Nafn" className="login-form-input form-control input-lg" valueLink={this.linkState("signup_name")} type="text" placeholder="Nafn"> <i className="far fa-user-astronaut"></i></Input>
                <Input label="Email" autoComplete="username" className="login-form-input form-control input-lg" valueLink={this.linkState("signup_email")} type="email" placeholder="E-mail"><i className="far fa-at"></i></Input>
                <Input label="Password" autoComplete="new-password" className="login-form-input form-control input-lg" valueLink={this.linkState("signup_password")} type="password" placeholder="Password"><i className="far fa-unlock"></i></Input>
                <Input label="Fyrirtæki" className="login-form-input form-control input-lg" valueLink={this.linkState("signup_company")} type="text" placeholder="Fyrirtæki (Valkvæmt)"><i className="far fa-building"></i></Input>
                <button className="btn" onClick={this.signUp}> Stofna {(this.props.loading) ? <span className="glyphicon glyphicon glyphicon-cog spin"></span> : <span className="glyphicon glyphicon-arrow-right"></span> }</button>
              </div>
            </div>
            <div className="form-container sign-in-container">
              <div id="login-form" className="form-group" onKeyDown={this.onKeyDown}>
                <h1>Innskráning</h1>
                <Input autoFocus name="email" autoComplete="username" label="Tölvupóstfang" className="login-form-input form-control input-lg" valueLink={this.linkState("email")} type="email" placeholder="Tölvupóstfang"><i className="far fa-at"></i></Input>
                <Input mame="password" autoComplete="current-password" label="Lykilorð" className="login-form-input form-control input-lg" valueLink={this.linkState("password")} type="password" placeholder="Lykilorð"><i className="far fa-unlock"></i></Input>
                <div className="reset-pass">Gleymt lykilorð</div>
                <button className="btn" onClick={this.login}> Innskrá {(this.props.loading) ? <span className="glyphicon glyphicon glyphicon-cog spin"></span> : <span className="glyphicon glyphicon-arrow-right"></span> }</button>
              </div>
            </div>
            <div className="overlay-container">
              <div className="btn-wrapper">
                <button className="btn" id="signIn" onClick={this.onToggleForm}>
                  <div className="btn-text signInBtnText">Skrá inn</div>
                  <div className="btn-text signUpBtnText">Stofna aðgang</div>
                </button>
              </div>
              <div className="overlay">
                  <div className="overlay-panel overlay-left">
                      <h2>Áttu aðgang?</h2>
                      <p>Ef þú átt nú þegar getur<br/> þú smellt á hnappinn til að skrá þig inn!</p>
                  </div>
                  <div className="overlay-panel overlay-right">
                      <h2>Vantar þig aðgang?</h2>
                      <p>Það tekur enga stund að stofna<br/> aðgang að Búnaðarbankanum!</p>
                  </div>
              </div>
            </div>
        </div>
    );
  }
});

module.exports = LoginSidebar;



// WEBPACK FOOTER //
// ./app/scripts/ui/Login/LoginSidebar.react.js